import { useEffect, useState } from 'react';

import { getTrustpilotScore } from '@/request/common';

const DEFAULT_SCORE = '4.8';

let cachedScore: string | null = null;
let fetchPromise: Promise<string> | null = null;

function fetchScore(): Promise<string> {
  if (!fetchPromise) {
    fetchPromise = getTrustpilotScore()
      .then(score => {
        const result = score ? String(score) : DEFAULT_SCORE;
        cachedScore = result;
        return result;
      })
      .catch(() => {
        fetchPromise = null;
        return DEFAULT_SCORE;
      });
  }
  return fetchPromise;
}

export default function useTrustpilotScore(): string {
  const [score, setScore] = useState(cachedScore ?? DEFAULT_SCORE);

  useEffect(() => {
    if (cachedScore) {
      setScore(cachedScore);
      return;
    }
    fetchScore().then(setScore);
  }, []);

  return score;
}
